import '../../assets/downlink-speed.svg.mjs';
import icon__default from "../../../../assets/downlink-speed.svg";
"use strict";
const downlinkSpeed = {
  id: "downlinkSpeed",
  title: "downlinkSpeed.title",
  icon: icon__default
};
export { downlinkSpeed };
//# sourceMappingURL=downlinkSpeed.mjs.map
